if (!customElements.get('mg-purchase')) {
  customElements.define('mg-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        if (this.bundlePriceForm) this.bundlePriceObserver?.observe(this.bundlePriceForm, {childList: true, subtree: true, characterData: true});
        this.startStickyPurchase();
        return;
      }
      this.initialized = true;
      const form = this.querySelector('form');
      if (!form) return;
      const quantity = form.elements.quantity;
      const button = form.querySelector('[type="submit"]');
      const text = button.querySelector('[data-button-text]');
      const error = form.querySelector('[data-error]');
      this.setupBundlePricing(form);
      this.setupStickyPurchase(form);
      this.querySelector('[data-bundle-panel]')?.removeAttribute('hidden');
      this.querySelectorAll('[data-step]').forEach(control => {
        control.hidden = false;
        control.addEventListener('click', () => {
          if (!quantity.value || !Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
          if (control.dataset.step === '1') quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      form.querySelector('[data-variant-select]')?.addEventListener('change', event => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', event.target.value);
        window.location.assign(url.href);
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || button.disabled || !form.reportValidity()) return;
        this.busy = true;
        const originalText = text.textContent;
        const controls = [...form.querySelectorAll('button, input, select')];
        const states = controls.map(control => control.disabled);
        const bundle = form.querySelector('[data-bundle-choice]:checked');
        const items = [{id:bundle?.value || form.elements.id.value, quantity:quantity.valueAsNumber}];
        controls.forEach(control => control.disabled = true);
        button.setAttribute('aria-busy', 'true');
        text.textContent = 'Toevoegen…';
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl + '.js', {
            method:'POST', credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items, sections:[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(component => component.dataset.sectionId))].slice(0, 5), sections_url:window.location.pathname})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Toevoegen is niet gelukt. Controleer de voorraad en het aantal.');
          text.textContent = 'Toegevoegd';
          if (document.getElementById('mg-cart-popup')?.dataset.ready) {
            try {
              const cartResponse = await fetch(this.dataset.cartUrl + '.js', {credentials:'same-origin', cache:'no-store'});
              if (!cartResponse.ok) throw new Error('cart');
              const cart = await cartResponse.json();
              this.dispatchEvent(new CustomEvent('mg:cart-added', {
                bubbles:true, detail:{cart, sections:result.sections, items}
              }));
              controls.forEach((control, index) => control.disabled = states[index]);
              button.removeAttribute('aria-busy');
              text.textContent = originalText;
              this.busy = false;
              return;
            } catch {
              window.location.assign(this.dataset.cartUrl);
              return;
            }
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message === 'Failed to fetch'
            ? 'Geen verbinding. Controleer je winkelwagen voordat je het opnieuw probeert.'
            : failure.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
          error.hidden = false;
          controls.forEach((control, index) => control.disabled = states[index]);
          button.removeAttribute('aria-busy');
          text.textContent = originalText;
          this.busy = false;
        }
      });
    }
    setupStickyPurchase(form) {
      const actions = form.querySelector('.mg-buy-actions');
      if (!actions) return;
      const dock = document.createElement('div');
      dock.className = 'mg-buy-dock';
      const inner = document.createElement('div');
      inner.className = 'mg-buy-dock-inner';
      const summary = document.createElement('div');
      summary.className = 'mg-buy-dock-summary';
      const title = document.createElement('span');
      title.className = 'mg-buy-dock-title';
      const price = document.createElement('strong');
      price.className = 'mg-buy-dock-price';
      summary.append(title, price);
      actions.before(dock);
      dock.append(inner);
      inner.append(summary, actions);
      const error = form.querySelector('[data-error]');
      if (error) inner.append(error);
      const panel = form.querySelector('[data-bundle-panel]');
      const format = new Intl.NumberFormat(panel?.dataset.locale || document.documentElement.lang || 'nl-NL', {
        style: 'currency', currency: panel?.dataset.currency || 'EUR'
      });
      const originalTitle = this.querySelector('h1')?.textContent.trim() || '';
      const originalPrice = this.querySelector('.mg-sale-now strong, .mg-buy-price')?.textContent.trim() || '';
      const basePrice = Math.round(Number(originalPrice.replace(/[^0-9,]/g, '').replace(',', '.')) * 100);
      const setText = (element, value) => {
        if (element.textContent !== value) element.textContent = value;
      };
      this.syncStickyPurchase = () => {
        const choice = panel?.querySelector('[data-bundle-choice]:checked');
        const bundlePrice = Number(choice?.dataset.bundlePrice);
        const isBundle = Boolean(choice?.value) && Number.isSafeInteger(bundlePrice) && bundlePrice > 0;
        const count = Math.max(1, form.elements.quantity.valueAsNumber || 1);
        let unit = isBundle ? bundlePrice : basePrice;
        const tiers = [...form.querySelectorAll('.mce-price-wrapper')]
          .filter(tier => Number(tier.dataset.qty) > 0 && Number(tier.dataset.qty) <= count)
          .sort((a, b) => Number(b.dataset.qty) - Number(a.dataset.qty));
        const discountedUnit = Number(tiers[0]?.dataset.price);
        if (Number.isFinite(discountedUnit) && discountedUnit > 0) unit = Math.round(discountedUnit * 100);
        const bundleTitle = isBundle ? choice.closest('label')?.querySelector('.mg-bundle-heading strong')?.textContent.trim() : '';
        const selection = originalTitle + (bundleTitle ? ' — ' + bundleTitle : '');
        setText(title, (count > 1 ? count + ' × ' : '') + selection);
        setText(price, Number.isSafeInteger(unit) ? format.format(unit * count / 100) : originalPrice);
      };
      this.stickyDock = dock;
      this.stickyActions = actions;
      this.stickyForm = form;
      this.stickyPriceObserver = new MutationObserver(() => this.syncStickyPurchase());
      this.startStickyPurchase();
    }
    startStickyPurchase() {
      if (!this.stickyDock) return;
      this.stickyEvents?.abort();
      this.stickyEvents = new AbortController();
      const signal = this.stickyEvents.signal;
      const update = () => {
        this.stickyFrame = 0;
        if (!this.isConnected) return;
        const height = this.stickyActions.offsetHeight;
        this.stickyDock.style.minHeight = height + 'px';
        this.stickyDock.classList.toggle('mg-buy-dock--fixed', this.stickyDock.getBoundingClientRect().bottom <= 0);
      };
      const schedule = () => {
        if (!this.stickyFrame) this.stickyFrame = requestAnimationFrame(update);
      };
      document.addEventListener('scroll', schedule, {passive: true, capture: true, signal});
      window.addEventListener('resize', schedule, {passive: true, signal});
      this.stickyForm.addEventListener('input', () => this.syncStickyPurchase(), {signal});
      this.stickyForm.addEventListener('change', () => this.syncStickyPurchase(), {signal});
      this.stickyPriceObserver.observe(this.stickyForm, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-price']});
      this.stickyResizeObserver?.disconnect();
      this.stickyResizeObserver = new ResizeObserver(schedule);
      this.stickyResizeObserver.observe(this);
      this.syncStickyPurchase();
      schedule();
    }

    setupBundlePricing(form) {
      const panel = this.querySelector('[data-bundle-panel]');
      if (!panel) return;
      const originals = new WeakMap();
      const headings = new WeakMap();
      const format = new Intl.NumberFormat(panel.dataset.locale || 'nl-NL', {
        style: 'currency', currency: panel.dataset.currency || 'EUR'
      });
      const setText = (element, value) => {
        if (element && element.textContent !== value) element.textContent = value;
      };
      const update = () => {
        const choice = panel.querySelector('[data-bundle-choice]:checked');
        const price = Number(choice?.dataset.bundlePrice);
        const isBundle = Boolean(choice?.value) && Number.isSafeInteger(price) && price > 0;
        for (const widget of form.querySelectorAll('.mce-vd-selector-wrapper')) {
          const title = widget.querySelector('.mce-selector-title');
          const subtitle = widget.querySelector('.mce-selector-subtitle');
          if (isBundle) {
            if (!headings.has(widget)) headings.set(widget, {title: title?.textContent, subtitle: subtitle?.textContent});
            setText(title, panel.dataset.tierTitle);
            setText(subtitle, panel.dataset.tierNote);
          } else if (headings.has(widget)) {
            const original = headings.get(widget);
            setText(title, original.title);
            setText(subtitle, original.subtitle);
            headings.delete(widget);
          }
          for (const tier of widget.querySelectorAll('.mce-price-wrapper')) {
            const regular = tier.querySelector('.mce-regular-price');
            const final = tier.querySelector('.mce-final-price');
            const label = tier.closest('.mce-selector-item')?.querySelector('.mce-price-title');
            const count = Number(tier.dataset.qty);
            const percent = Number(tier.dataset.discountPercentage);
            const amount = Number(tier.dataset.discountAmount || 0);
            if (isBundle && Number.isSafeInteger(count) && count > 0 && Number.isFinite(percent) && percent >= 0 && percent <= 100 && amount === 0) {
              if (!originals.has(tier)) originals.set(tier, {
                regular: regular?.textContent, final: final?.textContent,
                label: label?.textContent, price: tier.getAttribute('data-price')
              });
              const unit = Math.ceil((price * (100 - percent)) / 100 - 1e-9);
              setText(regular, format.format(price * count / 100));
              setText(final, format.format(unit * count / 100));
              setText(label, panel.dataset.tierQuantity.replace('[count]', String(count)));
              const unitPrice = (unit / 100).toFixed(2);
              if (tier.dataset.price !== unitPrice) tier.dataset.price = unitPrice;
            } else if (originals.has(tier)) {
              const original = originals.get(tier);
              setText(regular, original.regular);
              setText(final, original.final);
              setText(label, original.label);
              if (original.price === null) tier.removeAttribute('data-price');
              else tier.setAttribute('data-price', original.price);
              originals.delete(tier);
            }
          }
        }
      };
      this.bundlePriceObserver = new MutationObserver(update);
      this.bundlePriceForm = form;
      this.bundlePriceObserver.observe(form, {childList: true, subtree: true, characterData: true});
      form.addEventListener('change', update);
      update();
    }

    disconnectedCallback() {
      this.bundlePriceObserver?.disconnect();
      this.stickyEvents?.abort();
      this.stickyPriceObserver?.disconnect();
      this.stickyResizeObserver?.disconnect();
      cancelAnimationFrame(this.stickyFrame);
    }

  });
}

